/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEntity } from './RoleEntity';
import {
    RoleEntityFromJSON,
    RoleEntityFromJSONTyped,
    RoleEntityToJSON,
    RoleEntityToJSONTyped,
} from './RoleEntity';

/**
 * 
 * @export
 * @interface ListRolesResult
 */
export interface ListRolesResult {
    /**
     * ロール一覧
     * @type {Array<RoleEntity>}
     * @memberof ListRolesResult
     */
    roles: Array<RoleEntity>;
    /**
     * 総数
     * @type {number}
     * @memberof ListRolesResult
     */
    total: number;
}

/**
 * Check if a given object implements the ListRolesResult interface.
 */
export function instanceOfListRolesResult(value: object): value is ListRolesResult {
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ListRolesResultFromJSON(json: any): ListRolesResult {
    return ListRolesResultFromJSONTyped(json, false);
}

export function ListRolesResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRolesResult {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': ((json['roles'] as Array<any>).map(RoleEntityFromJSON)),
        'total': json['total'],
    };
}

export function ListRolesResultToJSON(json: any): ListRolesResult {
    return ListRolesResultToJSONTyped(json, false);
}

export function ListRolesResultToJSONTyped(value?: ListRolesResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': ((value['roles'] as Array<any>).map(RoleEntityToJSON)),
        'total': value['total'],
    };
}

